import { useEffect, useState } from 'react';
import { workspacesApi } from '../lib/api';

// Loads a single workspace by id.
export default function useWorkspace(workspaceId) {
  const [workspace, setWorkspace] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);

    workspacesApi
      .getById(workspaceId, controller.signal)
      .then(setWorkspace)
      .catch((err) => {
        if (err.name !== 'AbortError') setError(err.message);
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [workspaceId]);

  return { workspace, loading, error };
}
